import { render, staticRenderFns } from "./TaskUpdatedActivity.vue?vue&type=template&id=16cec5ac"
import script from "./TaskUpdatedActivity.vue?vue&type=script&lang=js"
export * from "./TaskUpdatedActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports